import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon, CalendarIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
const painPoints = ['Si en invierno o época de lluvia tu negocio prácticamente para', 'Si tienes equipos y empleados pero no suficiente trabajo para mantenerlos', 'Si la mayoría de tus clientes son "de una sola vez" y no contratos de mantenimiento recurrente', 'Si compites con "el vecino que tiene una podadora" y no sabes cómo diferenciarte', 'Si gastas en Facebook Ads y solo te llaman para preguntar el precio y desaparecen'];
export function HeroSection() {
  return <section className="relative min-h-screen flex flex-col justify-center items-center px-6 py-20 overflow-hidden" data-id="element-25">
      {/* Subtle background gradient to separate from pure black slightly at the top */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-gold/5 blur-[120px] rounded-full pointer-events-none" data-id="element-26" />

      <motion.div className="max-w-4xl w-full mx-auto relative z-10" variants={containerVariants} initial="hidden" animate="visible" data-id="element-27">
        <motion.div variants={itemVariants} className="text-center mb-10" data-id="element-28">
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-6 text-balance" data-id="element-29">
            ¿Tu negocio de <span className="text-gold" data-id="element-30">Landscaping</span> solo
            crece cuando hace buen tiempo?
          </h1>

          <div className="space-y-4 max-w-3xl mx-auto" data-id="element-31">
            <p className="text-lg md:text-xl text-neutral-300 font-body leading-relaxed" data-id="element-32">
              Instalamos un sistema que te trae contratos de mantenimiento
              mensual recurrente para que tu facturación sea predecible los 12
              meses del año.
            </p>
            <p className="text-xl md:text-2xl text-gold font-semibold font-heading" data-id="element-33">
              Sin depender de la temporada. Sin depender del clima.
            </p>
          </div>
        </motion.div>

        <motion.div variants={itemVariants} className="max-w-2xl mx-auto bg-carbon-light border border-carbon-lighter rounded-2xl p-6 md:p-8 mb-12 shadow-2xl" data-id="element-34">
          <ul className="space-y-5" data-id="element-35">
            {painPoints.map((point, index) => <motion.li key={index} variants={itemVariants} className="flex items-start gap-4" data-id="element-36">
                <XCircleIcon className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-37" />
                <span className="text-neutral-300 font-body text-base md:text-lg leading-snug" data-id="element-38">
                  {point}
                </span>
              </motion.li>)}
          </ul>
        </motion.div>

        <motion.div variants={itemVariants} className="flex flex-col items-center" data-id="element-39">
          <a href="https://calendar.app.google/PYPdcRoYne7QrNJA7" target="_blank" rel="noopener noreferrer" className="group relative inline-flex items-center justify-center gap-3 bg-gold hover:bg-gold-dark text-carbon font-heading font-bold text-lg md:text-xl px-8 py-5 rounded-xl transition-all duration-300 animate-cta-glow hover:scale-105 active:scale-95 w-full md:w-auto" data-id="element-40">
            <CalendarIcon className="w-6 h-6" data-id="element-41" />
            <span data-id="element-42">QUIERO CONTRATOS RECURRENTES</span>
          </a>
          <p className="mt-4 text-neutral-400 font-body text-sm" data-id="element-43">
            Diagnóstico gratuito en 15 minutos.
          </p>
        </motion.div>
      </motion.div>
    </section>;
}